import { render, staticRenderFns } from "./VirtualSupplierSideMenu.vue?vue&type=template&id=4f921c09&"
import script from "./VirtualSupplierSideMenu.vue?vue&type=script&lang=js&"
export * from "./VirtualSupplierSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports